import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton as MuiIconButton, makeStyles, Theme } from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import { PentairBlue, PentairSilverGray, PentairBrightBlue } from "../../theme/colors/_all";
import { Link } from "react-router-dom";

interface OwnProps extends Partial<IconButtonProps> {
  icon: IconName;
  active?: boolean;
  variant?: "default" | "primary";
  onClick?(e: React.MouseEvent): void;
  to?: string;
}

const useStyles = (props: OwnProps) => {
  return makeStyles((theme: Theme) => ({
    root: {
      borderRadius: 0,
      "&:hover": {
        "& $icon": {
          "& >:first-child": {
            opacity: 0
          },
          "& >:last-child": {
            opacity: 1
          }
        }
      }
    },
    icon: {
      color: PentairSilverGray[500],
      position: "relative",
      "& >:first-child": {
        opacity: 1,
        position: "absolute",
        transform: "translate(-50%, -50%)"
      },
      "& >:last-child": {
        opacity: 0,
        position: "absolute",
        transform: "translate(-50%, -50%)"
      },
      "&$primary": {
        color: "#fff"
      }
    },
    default: {
      color: PentairSilverGray[500],
      backgroundColor: "inherit",

      "& $icon": {
        "& >:last-child": {
          color: PentairBrightBlue[500]
        }
      },

      "&:hover": {
        "& $icon": {
          backgroundColor: PentairBrightBlue[500]
        }
      }
    },
    primary: {
      color: "#fff",
      backgroundColor: PentairBlue[500]
    },
    active: {
      "&$primary": {
        backgroundColor: "#fff"
      },
      "& $icon": {
        "& >:first-child": {
          opacity: 0
        },
        "& >:last-child": {
          opacity: 1,
          color: PentairBrightBlue[500]
        }
      }
    }
  }));
};
export function IconButton(props: OwnProps) {
  const classes = useStyles(props)();
  const variant = props.variant || "default";

  return props.to ? (
    <Link to={props.to || ""} onClick={props.onClick}>
      <MuiIconButton
        size={"small"}
        className={classNames(classes.root, props.active && classes.active, classes[variant])}
        {...props}
      >
        <div className={classNames(classes.icon, classes[variant])}>
          <FontAwesomeIcon icon={["fal", props.icon]} />
          <FontAwesomeIcon icon={["fas", props.icon]} />
        </div>
      </MuiIconButton>
    </Link>
  ) : (
    <MuiIconButton
      size={"small"}
      className={classNames(classes.root, props.active && classes.active, classes[variant])}
      {...props}
    >
      <div className={classNames(classes.icon, classes[variant])}>
        <FontAwesomeIcon icon={["fal", props.icon]} />
        <FontAwesomeIcon icon={["fas", props.icon]} />
      </div>
    </MuiIconButton>
  );
}
